import Vue from 'vue'
import 'babel-polyfill'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  showLoginBar: true,
  showCommonView: true,
  showInvoiceView: true
}

const mutations = {
  showLoginBarCut(state) {
    state.showLoginBar = !state.showLoginBar
  },
  showCommonViewCut() {
    state.showCommonView = !state.showCommonView
  },
  showInvoiceViewCut() {
    state.showInvoiceView = !state.showInvoiceView
  }
}

const actions = {
  //重新加载顶部登陆信息导航栏
  reloadLoginBar({ commit }) {
    commit('showLoginBarCut')
    setTimeout(() => {
      commit('showLoginBarCut')
    }, 1)
  },
  //重新加载commonFrame中的route-view
  reloadCommonView({ commit }) {
    commit('showCommonViewCut')
    setTimeout(() => {
      commit('showCommonViewCut')
    }, 1)
  },
  //重新加载centerFrame,agentFrame中的route_view
  reloadInvoiceView({ commit }) {
    commit('showInvoiceViewCut')
    setTimeout(() => {
      commit('showInvoiceViewCut')
    }, 1)
  }
}

//注册Store
export default new Vuex.Store({
  state,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js